module.exports = __webpack_public_path__ + "img/callkit_video2.f7dc042b.jpg";